
import dialogMethods from 'src/mixins/dialogMethods'
export default {
  name: 'AddressDetail',
  mixins: [dialogMethods],

  props: {
    PredefinitoPerRubrica: Boolean,
    commonId: [String, Number],
    createdAt: String,
    TipoIndirizzo: { type: String, required: true },
    label: { type: String, required: true },
    rest: { type: Object, required: true },
  },

  data() {
    return {
      loading: false,
      map: {
        confidence: null,
        coors: null,
        formatted: null,
      },

      icons: {
        Indirizzo: { icon: 'mdi-navigation', color: 'blue' },
        Cellulare: { icon: 'mdi-cellphone', color: 'teal' },
        Telefono1: { icon: 'mdi-cellphone', color: 'green' },
        Telefono2: { icon: 'mdi-cellphone', color: 'green' },
        Fax1: { icon: 'mdi-fax', color: 'brown' },
        Fax2: { icon: 'mdi-fax', color: 'brown' },
        Email: { icon: 'mdi-email', color: 'red' },
      },

      common: {
        Comune: null,
        CAP: null,
      },
    }
  },

  computed: {
    contacts() {
      return this.rest ? Object.fromEntries(Object.entries(this.rest).filter(([key, value]) => !!value && key !== 'Cap' && value.trim() !== '')) : {}
    },

    mapFound() { return !!this.map && !!this.map.coors && !!this.map.coors[0] },
  },

  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    async show() {
      try {
        this.$refs.dialog.show()
        this.loading = true
        const { data } = await this.$ax.get('resource/commons', { params: this.commonId })
        this.common = data
        // async () => {
        //   let q = `${this.contacts.Indirizzo} ${this.contacts.Cap || ''}, ${this.common.Comune}`
        //   this.map = await this.dispatch('getCoors', q, { root: true })
        // }
      } catch {
        this.$q.notify({ type: 'negative', message: `Comune non trovato: ${this.commonId}` })
        // er.name = 'AddressDetail/show'
        // throw er
      } finally { this.loading = false }
    },
  },
}
